import { render, staticRenderFns } from "./IncidentDetails.vue?vue&type=template&id=a9889a16&scoped=true"
import script from "./IncidentDetails.vue?vue&type=script&lang=js"
export * from "./IncidentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9889a16",
  null
  
)

export default component.exports